var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuizLockIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6905",
    "data-name": "Group 6905",
    transform: "translate(-1640 -528)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1224",
    "data-name": "Ellipse 1224",
    cx: 29,
    cy: 29,
    r: 29,
    transform: "translate(1640 528)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-lock",
    "data-name": "Icon awesome-lock",
    d: "M25.587,14.329H24.052V9.723a9.723,9.723,0,0,0-19.446,0v4.606H3.07A3.071,3.071,0,0,0,0,17.4V29.681a3.071,3.071,0,0,0,3.07,3.07H25.587a3.071,3.071,0,0,0,3.07-3.07V17.4A3.071,3.071,0,0,0,25.587,14.329Zm-6.653,0H9.723V9.723a4.606,4.606,0,0,1,9.211,0Z",
    transform: "translate(1654.671 539.625)",
    fill: "#51aabc"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuizLockIcon);
export default __webpack_public_path__ + "static/media/quiz-lock-icon.313719c1.svg";
export { ForwardRef as ReactComponent };